import { render } from "./App.vue?vue&type=template&id=4edd84d0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4edd84d0&lang=less"
script.render = render

export default script